import React from "react";
import {
  Button,
  Container,
  Header,
  SpaceBetween,
  KeyValuePairs,
} from "@amzn/awsui-components-react";
import { OptionDefinition } from "./StamperWizard";
import { StamperTable } from "./StamperTable";
import { WeblabTable } from "./WeblabTable";
import { LivenessState } from "./stamperWizardConnector";
import { AsinWithListOfMarketplaces } from "./StamperWizard";
import { FormField } from "@amzn/awsui-components-react/polaris";

type ReviewOptionsProps = {
  dispatch: any;
  asinsMarketplaceLiveness: { [key: string]: LivenessState };
  asinsWithListOfMarketplaces: AsinWithListOfMarketplaces[];
  weblabSelected: boolean;
  stampSelected: boolean;
  programs: OptionDefinition[];
  program?: string;
  programName?: string;
  partiness?: string;
  type?: string;
  setActiveStepIndex: any;
};

const Review = ({
  dispatch,
  asinsMarketplaceLiveness,
  asinsWithListOfMarketplaces,
  weblabSelected,
  stampSelected,
  programs,
  program,
  programName,
  partiness,
  type,
  setActiveStepIndex,
}: ReviewOptionsProps) => {
  const participationString =
    !program || !partiness || !type
      ? undefined
      : `c2l-v1-${program}|${partiness}|${type}`;

  return (
    <div>
      <SpaceBetween size="xxl" direction={"vertical"}>
        <SpaceBetween size="l" className="step-1-review">
          <Header
            variant="h3"
            headingTagOverride="h2"
            actions={
              <Button
                className="edit-step-btn"
                onClick={() => {
                  setActiveStepIndex(0);
                }}
              >
                Edit
              </Button>
            }
          >
            Step 1: ASIN Setup
          </Header>
          <Container
            header={
              <Header variant="h2" headingTagOverride="h3">
                ASIN Marketplace Attributes
              </Header>
            }
          >
            <SpaceBetween size={"xl"} direction={"vertical"}>
              {stampSelected ? <StamperTable /> : <></>}
              {weblabSelected ? <WeblabTable /> : <></>}
            </SpaceBetween>
          </Container>
        </SpaceBetween>

        <SpaceBetween size="xs" className="step-2-review">
          <Header
            variant="h3"
            headingTagOverride="h2"
            actions={
              <Button
                className="edit-step-btn"
                onClick={() => {
                  setActiveStepIndex(1);
                }}
              >
                Edit
              </Button>
            }
          >
            Step 2: Stamper Tool Options
          </Header>
          <Container
            header={
              <Header variant="h2" headingTagOverride="h3">
                Option Attributes
              </Header>
            }
          >
            {weblabSelected && !stampSelected ? (
              <FormField stretch={true}>
                <KeyValuePairs
                  columns={2}
                  items={[
                    {
                      label: "Program",
                      value: programName,
                      type: "pair",
                    },
                  ]}
                />
              </FormField>
            ) : (
              <FormField stretch={true}>
                <KeyValuePairs
                  columns={2}
                  items={[
                    {
                      label: "Program",
                      value: programName,
                      type: "pair",
                    },
                    {
                      label: "ASIN Party",
                      value: partiness,
                    },
                    {
                      label: "ASIN Type",
                      value: type,
                    },
                    {
                      label: "Program Participation Stamp",
                      value: participationString,
                    },
                  ]}
                />
              </FormField>
            )}
          </Container>
        </SpaceBetween>
      </SpaceBetween>
    </div>
  );
};

export default Review;
